function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.00057 6.50309C5.55317 6.50309 6.00114 6.05512 6.00114 5.50252C6.00114 4.94992 5.55317 4.50195 5.00057 4.50195C4.44797 4.50195 4 4.94992 4 5.50252C4 6.05512 4.44797 6.50309 5.00057 6.50309Z",
  stroke: "#4C4C4C",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.85015 1.63358L6.14499 2.6028C6.24566 2.9365 6.58772 3.1351 6.92743 3.05706L7.90999 2.82893C8.29216 2.74283 8.68584 2.91581 8.88089 3.25555C9.07594 3.59528 9.02685 4.02247 8.75981 4.30911L8.07275 5.0502C7.83465 5.30623 7.83465 5.70268 8.07275 5.95871L8.75981 6.6998C9.02727 6.98624 9.07659 7.41364 8.8814 7.75346C8.68621 8.09329 8.29217 8.26603 7.90999 8.17931L6.92743 7.95185C6.58767 7.87346 6.24538 8.07218 6.14499 8.40611L5.85015 9.37133C5.73722 9.74646 5.39176 10.0032 5 10.0032C4.60824 10.0032 4.26278 9.74646 4.14985 9.37133L3.85501 8.40277C3.75462 8.06885 3.41233 7.87013 3.07257 7.94851L2.09001 8.17598C1.70783 8.26269 1.31379 8.08995 1.1186 7.75013C0.923406 7.4103 0.972727 6.9829 1.24019 6.69647L1.92725 5.95538C2.16535 5.69934 2.16535 5.3029 1.92725 5.04686L1.24019 4.30577C0.97315 4.01914 0.924055 3.59195 1.11911 3.25221C1.31416 2.91247 1.70784 2.73949 2.09001 2.82559L3.07257 3.05372C3.41228 3.13176 3.75434 2.93317 3.85501 2.59946L4.14985 1.63024C4.26351 1.25533 4.60948 0.999233 5.00124 1C5.393 1.00077 5.73796 1.25822 5.85015 1.63358Z",
  stroke: "#4C4C4C",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgOperations = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "operations",
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOperations, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/operations.6b074ea7.svg";
export { ForwardRef as ReactComponent };